// Arab and major countries with flag emojis and country codes
const countries = [
  { code: 'IQ', flag: '🇮🇶', name_ar: 'العراق', name_en: 'Iraq' },
  { code: 'SA', flag: '🇸🇦', name_ar: 'المملكة العربية السعودية', name_en: 'Saudi Arabia' },
  { code: 'AE', flag: '🇦🇪', name_ar: 'الإمارات العربية المتحدة', name_en: 'United Arab Emirates' },
  { code: 'KW', flag: '🇰🇼', name_ar: 'الكويت', name_en: 'Kuwait' },
  { code: 'QA', flag: '🇶🇦', name_ar: 'قطر', name_en: 'Qatar' },
  { code: 'BH', flag: '🇧🇭', name_ar: 'البحرين', name_en: 'Bahrain' },
  { code: 'OM', flag: '🇴🇲', name_ar: 'عُمان', name_en: 'Oman' },
  { code: 'JO', flag: '🇯🇴', name_ar: 'الأردن', name_en: 'Jordan' },
  { code: 'LB', flag: '🇱🇧', name_ar: 'لبنان', name_en: 'Lebanon' },
  { code: 'SY', flag: '🇸🇾', name_ar: 'سوريا', name_en: 'Syria' },
  { code: 'PS', flag: '🇵🇸', name_ar: 'فلسطين', name_en: 'Palestine' },
  { code: 'EG', flag: '🇪🇬', name_ar: 'مصر', name_en: 'Egypt' },
  { code: 'LY', flag: '🇱🇾', name_ar: 'ليبيا', name_en: 'Libya' },
  { code: 'TN', flag: '🇹🇳', name_ar: 'تونس', name_en: 'Tunisia' },
  { code: 'DZ', flag: '🇩🇿', name_ar: 'الجزائر', name_en: 'Algeria' },
  { code: 'MA', flag: '🇲🇦', name_ar: 'المغرب', name_en: 'Morocco' },
  { code: 'SD', flag: '🇸🇩', name_ar: 'السودان', name_en: 'Sudan' },
  { code: 'YE', flag: '🇾🇪', name_ar: 'اليمن', name_en: 'Yemen' },
  { code: 'SO', flag: '🇸🇴', name_ar: 'الصومال', name_en: 'Somalia' },
  { code: 'MR', flag: '🇲🇷', name_ar: 'موريتانيا', name_en: 'Mauritania' },
  { code: 'DJ', flag: '🇩🇯', name_ar: 'جيبوتي', name_en: 'Djibouti' },
  { code: 'KM', flag: '🇰🇲', name_ar: 'جزر القمر', name_en: 'Comoros' },
  { code: 'TR', flag: '🇹🇷', name_ar: 'تركيا', name_en: 'Turkey' },
  { code: 'IR', flag: '🇮🇷', name_ar: 'إيران', name_en: 'Iran' },
  { code: 'PK', flag: '🇵🇰', name_ar: 'باكستان', name_en: 'Pakistan' },
  { code: 'IN', flag: '🇮🇳', name_ar: 'الهند', name_en: 'India' },
  { code: 'CN', flag: '🇨🇳', name_ar: 'الصين', name_en: 'China' },
  { code: 'US', flag: '🇺🇸', name_ar: 'الولايات المتحدة', name_en: 'United States' },
  { code: 'GB', flag: '🇬🇧', name_ar: 'المملكة المتحدة', name_en: 'United Kingdom' },
  { code: 'DE', flag: '🇩🇪', name_ar: 'ألمانيا', name_en: 'Germany' },
  { code: 'FR', flag: '🇫🇷', name_ar: 'فرنسا', name_en: 'France' },
  { code: 'IT', flag: '🇮🇹', name_ar: 'إيطاليا', name_en: 'Italy' },
  { code: 'ES', flag: '🇪🇸', name_ar: 'إسبانيا', name_en: 'Spain' },
  { code: 'JP', flag: '🇯🇵', name_ar: 'اليابان', name_en: 'Japan' },
  { code: 'KR', flag: '🇰🇷', name_ar: 'كوريا الجنوبية', name_en: 'South Korea' },
  { code: 'BR', flag: '🇧🇷', name_ar: 'البرازيل', name_en: 'Brazil' },
  { code: 'RU', flag: '🇷🇺', name_ar: 'روسيا', name_en: 'Russia' },
  { code: 'AU', flag: '🇦🇺', name_ar: 'أستراليا', name_en: 'Australia' },
  { code: 'CA', flag: '🇨🇦', name_ar: 'كندا', name_en: 'Canada' },
  { code: 'MY', flag: '🇲🇾', name_ar: 'ماليزيا', name_en: 'Malaysia' },
  { code: 'ID', flag: '🇮🇩', name_ar: 'إندونيسيا', name_en: 'Indonesia' },
  { code: 'NG', flag: '🇳🇬', name_ar: 'نيجيريا', name_en: 'Nigeria' },
  { code: 'ZA', flag: '🇿🇦', name_ar: 'جنوب أفريقيا', name_en: 'South Africa' },
];

export const getCountryByCode = (code) => countries.find(c => c.code === code);

export default countries;
